import AddCircle from '@/components/customercenter-ui/svgs/addCircle';
import InputField from '../../ui/customInput/input';
import { StateDropDown } from '../../ui/customSelect/stateDropDown';
const FormFields = ({
  Texts,
  FORM_FIELD_SPECS,
  register,
  errors,
  showadditionalAddressInfo,
  handleShowAdditionalAddressInfo,
  values,
  setValue,
}: any) => {
  return (
    <section>
      <section className="flex w-full gap-x-2 pt-2 lg:px-5">
        <section className="mb-2 w-full lg:max-w-[398px]">
          <InputField
            items={Texts.formItemAddress}
            id={FORM_FIELD_SPECS.addressLine1.id}
            htmlFor={FORM_FIELD_SPECS.addressLine1.id}
            register={register}
            errors={errors}
            label={FORM_FIELD_SPECS.addressLine1.label}
            classname="w-full address-input"
            maxLength={30}
          />
        </section>
      </section>
      {!showadditionalAddressInfo && (
        <button
          type="button"
          className="flex items-center gap-x-2 pb-5 lg:px-5"
          onClick={handleShowAdditionalAddressInfo}
        >
          <AddCircle className="h-5 w-5" />
          <p className="text-base font-normal leading-5">{Texts.formItemAdditionalAddressInfo}</p>
          <p className="text-sm font-normal leading-5">{Texts.formOptionalItem}</p>
        </button>
      )}
      <section className={`${!showadditionalAddressInfo ? 'hidden ' : 'block'} flex w-full items-center pt-2 lg:px-5`}>
        <section className="mb-2 w-full lg:max-w-[398px]">
          <InputField
            items={Texts.formItemAdditionalAddressInfo}
            id={FORM_FIELD_SPECS.additionalAddressInfo.id}
            htmlFor={FORM_FIELD_SPECS.additionalAddressInfo.id}
            register={register}
            errors={errors}
            label={FORM_FIELD_SPECS.additionalAddressInfo.label}
            classname="w-full addressLine2"
            maxLength={30}
          />
        </section>
      </section>
      <section className="flex w-full items-center lg:px-5">
        <section className="mb-2 w-full lg:max-w-[398px]">
          <InputField
            items={Texts.formItemCity}
            id={FORM_FIELD_SPECS.city.id}
            htmlFor={FORM_FIELD_SPECS.city.id}
            register={register}
            errors={errors}
            label={FORM_FIELD_SPECS.city.label}
            classname="w-full city"
            maxLength={30}
          />
        </section>
      </section>
      <section className="flex gap-x-5 pt-2 lg:w-full lg:px-5">
        <section className="w-full lg:max-w-[217px]">
          <StateDropDown
            setValue={setValue}
            errors={errors}
            label="state"
            classname="w-full state"
            initialState={values?.state}
            register={register}
            id="state"
          />
        </section>
        <section className="w-full max-w-[136px] lg:max-w-[161px]">
          <InputField
            items={Texts.formItemZipCode}
            id={FORM_FIELD_SPECS.postalCode.id}
            htmlFor={FORM_FIELD_SPECS.postalCode.id}
            register={register}
            errors={errors}
            label={FORM_FIELD_SPECS.postalCode.label}
            maxLength={10}
            classname="w-full zip"
          />
        </section>
        <section className="hidden">
          <InputField
            id={FORM_FIELD_SPECS.country.id}
            htmlFor={FORM_FIELD_SPECS.country.id}
            register={register}
            errors={errors}
            label={FORM_FIELD_SPECS.country.id}
            classname="w-full country"
            value={FORM_FIELD_SPECS.country.default}
            type={FORM_FIELD_SPECS.country.type}
          />
        </section>
      </section>
    </section>
  );
};

export default FormFields;
